import axios from '../utils/axios';

export default function fetchTagsList(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/tags-list', { params })
    )
}
